import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'button-cancelar-pessoa-fisica',
  templateUrl: './button-cancelar.component.html',
  styleUrls: ['./button-cancelar.component.scss']
})
export class ButtonCancelarComponent implements OnInit {

  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}

}
